import { render, staticRenderFns } from "./Fans.vue?vue&type=template&id=8034e904&scoped=true&"
import script from "./Fans.vue?vue&type=script&lang=js&"
export * from "./Fans.vue?vue&type=script&lang=js&"
import style0 from "./Fans.vue?vue&type=style&index=0&id=8034e904&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8034e904",
  null
  
)

export default component.exports